// Email Verification Card
export const dialogTitle = 'Please confirm your email address';
export const dialogSubTitle = 'This email will be used for site updates, including e-delivery notifications.';
export const dialogContent = 'Your current email:';
export const dialogContentTwo = 'A one-time use code will be sent to validate your email address.';
export const dialogContentThree = 'Use a different email';
export const confirmButton = 'Confirm';
export const dialogTitleTwo = 'Enter your new email address';
export const cancelButton = 'Cancel';
export const saveButton = 'Save new email';
export const dialogTitleThree = 'Enter your one-time code';
export const otcDialogContenet =
  'A one time use code has been sent to your email account. Enter this code above to validate your new address and activate it for this website.';
export const newCodeButton = 'Request a new code';
export const validateButton = 'Validate';

// Delivery Card
export const preferenceDialogTitle = 'Electronic delivery preference';
export const deliveryBody =
  'To continue, please select your electronic delivery preference. This selection will apply to required disclosures as well as other communications, including account statements, records of transactions, prospectuses, and certain tax documents (Schedules K-1, Forms 1099, and others).';
export const warningBody =
  'Other users with access to the same accounts must also elect the same delivery preference. Any change you make to your preferences above will only take effect once these users make the same election. Below are users and their current delivery preferences are listed below.';
export const subTitle = 'Other users with access to the same account';
export const consentBody = 'By clicking "I consent" below, you acknowledge that you have reviewed the';
export const consentBodyTwo = 'Electronic Delivery Consent Agreement';
export const consentBodyThree =
  ', understand and agree to its terms and conditions, and that you are able to open, download, save, or print documents posted on this site.';
export const consentButton = 'I consent';
